<template>
  <v-menu
    open-on-hover
    top
    nudge-top="30px"
  >
    <template v-slot:activator="{ on }">
      <v-chip
        label
        small
        :color="color"
        style="cursor: pointer"
        v-on="on"
      >
        &#8226;
        {{ severityLabel }}
      </v-chip>
    </template>
    <v-card>
      <v-card-text>
        <human-body-female-front-muscles
          v-if="gender === 'female'"
          style="height: 205px; width: 130px"
          :stats="playerStats"
          :stats-suffix="statsSuffix"
        />
        <human-body-front-muscles
          v-else
          class="mx-3"
          style="height: 205px; width: 130px"
          :stats="playerStats"
          :stats-suffix="statsSuffix"
        />
        <human-body-female-back-muscles
          v-if="gender === 'female'"
          class="mx-3"
          style="height: 205px; width: 130px"
          :stats="playerStats"
          :stats-suffix="statsSuffix"
        />
        <human-body-back-muscles
          v-else
          class="mx-3"
          style="height: 205px; width: 130px"
          :stats="playerStats"
          :stats-suffix="statsSuffix"
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import HumanBodyFrontMuscles from '@/components/human-body/HumanBodyFrontMuscles.vue'
import HumanBodyBackMuscles from '@/components/human-body/HumanBodyBackMuscles.vue'
import HumanBodyFemaleFrontMuscles from '@/components/human-body/HumanBodyFemaleFrontMuscles.vue'
import HumanBodyFemaleBackMuscles from '@/components/human-body/HumanBodyFemaleBackMuscles.vue'

export default {
  name: 'PainLabel',
  components: { HumanBodyFemaleBackMuscles, HumanBodyFemaleFrontMuscles, HumanBodyBackMuscles, HumanBodyFrontMuscles },
  props: {
    value: {
      type: Number,
      default: 0
    },
    playerStats: {
      type: [Object, Array],
      default: () => ({})
    },
    gender: {
      type: String,
      default: 'male'
    },
    statsSuffix: {
      type: String,
      default: '_DL'
    }
  },
  computed: {
    color() {
      if (this.value === 1) return 'orange lighten-1'
      if (this.value === 2) return 'orange darken-2'
      if (this.value === 3) return 'error'

      return 'grey lighten-3'
    },
    severityLabel() {
      if (this.value === 1) return this.$t('pain_type.low')
      if (this.value === 2) return this.$t('pain_type.medium')
      if (this.value === 3) return this.$t('pain_type.high')

      return this.$t('pain_type.no_pain')
    }
  }
}
</script>
